let currentUserId: number | null = null;

export const setProductDemoRuntimeUserId = (userId?: number | null) => {
  currentUserId = userId ?? null;
};

export const getProductDemoRuntimeUserId = () => currentUserId;
